import SlideoutDocumentCard from './SlideoutDocumentCard'
export default SlideoutDocumentCard